<template>
  <div id="page-help">
    <h1>help page</h1>           
  </div>
</template>




<script>
export default {
  name: "help"
}

</script>
